import {getCall,listCall,postCall,putCall,delCall} from "./commonApi";

export async function getOrganizationGroup(orgId) {
    let res = await getCall('/general/get/organizationGroups/'+orgId);
    return res;
}

export async function getOrganizationGroups() {
    let res = await listCall('/list/organizationGroups');
    return res;
}

export async function getTiles(params) {
    let res = await listCall('/list/reportingTiles'+params);
    return res;
}

export async function createOrganizationGroup(data) {
    let res = await postCall("/general/create/organizationGroups",data);
    return res;
}

export async function createTile(data) {
    let res = await postCall("/general/create/addNewTile",data);
    return res;
}

export async function removeTile(id,accessLevel) {
    let res = await delCall('/general/removeTile/'+id+'/'+accessLevel);
    return res;
}

export async function updateOrganizationGroup(orgId,data) {
    let res = await putCall('/general/update/organizationGroups/'+orgId,data);
    return res;
}

export async function updateOrganizationStatus(orgId,data) {
    let res = await putCall('/general/updateOrgStatus/'+orgId,data);
    return res;
}

export async function updateDashboardName(dashboardId,data) {
    let res = await putCall('/general/update/reportingTiles/'+dashboardId,data);
    return res;
}

export async function updateFollowupDates(data) {
    let res = await putCall('/general/updateFollowupDates',data);
    return res;
}
